import React from 'react';
import { Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark border-t border-gold/20 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
          <div>
            <h3 className="text-2xl font-playfair font-bold text-gold mb-4">JENMA</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              L'excellence en agencement intérieur. Chaque projet est une œuvre unique 
              où la précision rencontre l'esthétique.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wide text-sm">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <a href="/#about" className="text-gray-400 hover:text-gold transition-colors duration-300 text-sm">
                  À propos
                </a>
              </li>
              <li>
                <a href="/#expertise" className="text-gray-400 hover:text-gold transition-colors duration-300 text-sm">
                  Expertise
                </a>
              </li>
              <li>
                <a href="/#portfolio" className="text-gray-400 hover:text-gold transition-colors duration-300 text-sm">
                  Projets
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-400 hover:text-gold transition-colors duration-300 text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wide text-sm">Suivez-nous</h4>
            <div className="flex space-x-4">
              
              <a 
                href="https://fr.linkedin.com/in/tommy-saadoun-b724a94a" target="_blank" rel="noreferrer"
                className="w-10 h-10 bg-gold/10 rounded-sm flex items-center justify-center hover:bg-gold hover:text-dark text-gold transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              
            </div>
          </div>
        </div>
        
        <div className="border-t border-gold/10 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} JENMA Concept. Tous droits réservés. Créé avec précision et passion.
          </p>
          <nav className="mt-4 flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs uppercase tracking-[0.2em]" data-testid="footer-legal-nav">
            <a href="/contact" data-testid="footer-contact-link" className="text-gray-500 hover:text-gold transition-colors">Contact</a>
            <a href="/configurateur" className="text-gray-500 hover:text-gold transition-colors">Configurateur</a>
            <a href="/services" className="text-gray-500 hover:text-gold transition-colors">Services</a>
            <a href="/avis-clients" data-testid="footer-reviews-link" className="text-gray-500 hover:text-gold transition-colors">Avis clients</a>
            <a href="/mentions-legales" data-testid="footer-legal-link" className="text-gray-500 hover:text-gold transition-colors">Mentions légales</a>
          </nav>
        </div>
      </div>
    </footer>
  );
};
